import request from './request'

// Login do usuário
export function categoryList() {
  return request({
    url: '/home/categorys',
    method: 'get'
  })
}

export function categoryDetail(params){
  return request({
    url: '/home/category',
    method: 'get',
    params
  })
}

export function homeIndex(params){
  return request({
    url: '/home/index',
    method: 'get',
    params
  })
}
export function homeStat(){
  return request({
    url: '/home/stat',
    method: 'get'
  })
}

export function doRegister(data) {
  return request({
    url: '/user/register',
    method: 'post',
    data
  })
}

export function getConfig(){
  return request({
    url: '/home/config',
    method: 'get'
  })
}